import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { Router } from '@angular/router';
import { TaskExecution } from '@shared/task/task-execution';
import { TaskExecutionApi } from '@shared/task/task-execution-api.service';

@Component({
  selector: 'app-failed-tasks-widget',
  templateUrl: './failed-tasks-widget.component.html',
  styleUrls: ['./failed-tasks-widget.component.scss'],
  imports: [
    MatTable,
    MatHeaderCell,
    MatCell,
    MatCellDef,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRowDef,
    MatRow,
    MatColumnDef,
    DatePipe,
  ],
})
export class FailedTasksWidgetComponent implements OnInit {
  taskExecutions!: TaskExecution[];

  displayedColumns = ['startDate', 'name', 'description', 'error'];

  constructor(
    private readonly taskExecutionApi: TaskExecutionApi,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.taskExecutionApi.findFailedTasks().subscribe(value => {
      this.taskExecutions = value.sort(this.sort);
    });
  }

  protected sort(value1: TaskExecution, value2: TaskExecution): number {
    if (!value1) {
      return 0;
    }

    if (value1.startDate && value2.startDate) {
      return new Date(value2.startDate).getTime() - new Date(value1.startDate).getTime();
    }

    return -1;
  }

  getName(task: TaskExecution): string | undefined {
    return task.taskDefinition?.name;
  }

  formatDescription(task: TaskExecution): string | undefined {
    return task.description || task.taskDefinition?.description;
  }

  formatError(task: TaskExecution): string {
    return task.exitCode && task.exitCode > 1 ? `Error code: ${task.exitCode}` : `${task.rowsNotOk} rows not OK`;
  }

  onRowClick(task: TaskExecution): void {
    this.router.navigate([`/tasks/executions/${task.uuid}`]);
  }
}
